import { render, staticRenderFns } from "./ShowPayReceiveDocs.vue?vue&type=template&id=7d5c0814&"
import script from "./ShowPayReceiveDocs.vue?vue&type=script&lang=js&"
export * from "./ShowPayReceiveDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports